import { useMemo } from 'react';

import { usePremissionContext } from './use-permissions-context';

type ModulePermissionKeys = 'create' | 'import' | 'export';

interface ModulePermissions {
  isView: boolean;
  isCreate: boolean;
  isImport: boolean;
  isExport: boolean;
  isEdit: boolean;
  isDelete: boolean;
}

/**
 * Returns named boolean permissions for create, import, and export actions
 * @param moduleName - The module to check (e.g., 'contact')
 * @returns An object with isCreate, isImport, and isExport booleans
 */
export const useModulePermissions = (moduleName: string): ModulePermissions => {
  const { hasModuleActionPermission } = usePremissionContext();
  const updateModuleName =
    moduleName?.toLocaleLowerCase() === 'labels' ? 'label' : moduleName?.toLocaleLowerCase();
  return useMemo(
    () => ({
      isView: hasModuleActionPermission(updateModuleName, 'view'),
      isCreate: hasModuleActionPermission(updateModuleName, 'create'),
      isImport: hasModuleActionPermission(updateModuleName, 'import'),
      isExport: hasModuleActionPermission(updateModuleName, 'export'),
      isEdit: hasModuleActionPermission(updateModuleName, 'edit'),
      isDelete: hasModuleActionPermission(updateModuleName, 'delete'),
    }),
    [moduleName]
  );
};
